import { render, staticRenderFns } from "./receipt-form.vue?vue&type=template&id=c40f0930"
import script from "./receipt-form.vue?vue&type=script&lang=js"
export * from "./receipt-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports